export enum FlowRoute {
  Onboarding = 'onboarding',
  VehicleOnboarding = 'onboarding/vehicle',
  /** The upsell, entered from the app with a token rather than from the web. */
  UpsellEnergy = 'upsell/energy',
  /** Universal link target the native apps intercept to hand off back to the app. */
  UpsellReturnToApp = 'upsell/return-to-app',
}
